const palette = {
  // alternate: {
  //   main: '#09A3A9',
  //   contrastText: '#FFFFFF',
  // },
  'light-alternate': {
    main: '#E6F6F6',
  },
  'green-02': {
    main: '#0F6264',
    contrastText: '#FFFFFF',
  },
  'light-green-02': {
    main: '#EDF6F6',
  },
  'yellow-01': {
    main: '#F3BF3A',
  },
  'light-yellow-01': {
    main: '#FDF6E2',
  },
  'yellow-02': {
    main: '#D09A01',
  },
  'dark-text': {
    main: '#3A3A3A',
  },
  'light-gray-text': {
    main: '#8A8A8A',
  },
  'light-gray-text-2': {
    main: '#C6CAC9',
  },
  'gray-line': {
    main: '#E5E5E5',
  },
  'gray-menu-hover': {
    main: '#F3F6F9',
  },
  'gray-inactive-button': {
    main: '#E5E5E5',
  },
  'gray-background': {
    main: '#F7F9FA',
  },
  'default-background': {
    main: '#FAFAFA',
  },
  success: {
    main: '#2FED64',
  },
  'light-success': {
    main: '#E0FCE8',
  },
  error: {
    main: '#EB5757',
    light: 'rgba(235, 87, 87, 0.1)',
  },
  'light-error': {
    main: '#FDEEEE',
  },
  // warning: {
  //   main: '#E2B93B',
  // },
  'light-warning': {
    main: '#FBF5E2',
  },
  information: {
    main: '#2F80ED',
  },
  'light-information': {
    main: '#EAF2FD',
  },
  orange: {
    main: '#FFE0C9',
    contrastText: '#FF7A14',
  },
  white: {
    main: '#FFFFFF',
  },
  primary: {
    main: '#F3BF3A',
    light: '#FDF6E2',
    hover: '#D09A01',
    contrastText: '#262626',
  },
  contrastText: {
    main: '#262626',
  },
  alternate: {
    main: '#2666BE',
    light: '#DEECFF',
  },
  text: {
    primary: '#3A3A3A',
    secondary: '#8A8A8A',
    tertiary: '#C6CAC9',
    quaternary: '#8D9593',
    white: '#FFFFFF',
  },
  grayscale: {
    'line-dark': '#8A8A8A',
    'line-light': '#E5E5E5',
    'gray-inactive': '#E5E5E5',
    'gray-background': '#EDEFF0',
    'base-background': '#F7F9FA',
  },
  negative: {
    main: '#EB5757',
    light: '#FDEEEE',
  },
  positive: {
    main: '#2FED64',
    light: '#E0FCE8',
  },
  warning: {
    main: '#E2B93B',
    light: '#FBF5E2',
  },
  info: {
    main: '#2F80ED',
    light: '#EAF2FD',
  },
  background: {
    main: '#FFFFFF',
    contrastText: '#636363',
  },
  border: '#B57D00',
}

export default palette
